jQuery(function ($) {
  $(document).on("click", ".faq-question", function (event) {
    event.preventDefault();
    $(this).parent().toggleClass("active");
    $(this).toggleClass("active");
    $(this).next(".faq-answer").slideToggle();
  });
});
